<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div class="Polaris-Box Polaris-Box--printHidden">
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter mr-2"
              type="button"
              @click="openTemplates"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Templates</span
              >
            </button>
            <button
              class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
              type="button"
              @click="refreshCurrentPage"
              :disabled="isLoading"
            >
              <span
                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >Refresh</span
              >
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div v-if="isLoading">
              <Spinner />
            </div>

            <div class="flex flex-col">
              <div
                class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              >
                <!-- <ManualMessageAlert /> -->
                <div
                  class="align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-8"
                >
                  <div class="Polaris-LegacyCard">
                    <div
                      class="Polaris-IndexFilters__IndexFiltersWrapper"
                      style="height: 45px;"
                    >
                      <div></div>
                      <div class="Polaris-IndexFilters">
                        <div>
                          <div class="Polaris-IndexFilters-Container">
                            <div
                              class="Polaris-InlineStack"
                              style="--pc-inline-stack-align:start;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-0);--pc-inline-stack-gap-md:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                            >
                              <div class="Polaris-IndexFilters__TabsWrapper">
                                <div
                                  style="transition:opacity 150ms var(--p-motion-ease);opacity:1"
                                >
                                  <div class="Polaris-Tabs__Outer">
                                    <div
                                      class="Polaris-Box"
                                      style="--pc-box-padding-block-start-md:var(--p-space-200);--pc-box-padding-block-end-md:var(--p-space-200);--pc-box-padding-inline-start-md:var(--p-space-200);--pc-box-padding-inline-end-md:var(--p-space-200)"
                                    >
                                      <div class="Polaris-Tabs ">
                                        <li
                                          class="Polaris-Tabs__TabContainer"
                                          role="presentation"
                                        >
                                          <button
                                            class="Polaris-Tabs__Tab"
                                            :class="{
                                              'Polaris-Tabs__Tab--active':
                                                currentFilterType ===
                                                'abandoned'
                                            }"
                                            role="tab"
                                            type="button"
                                            @click="changeFilter('abandoned')"
                                          >
                                            <div
                                              class="Polaris-InlineStack"
                                              style="--pc-inline-stack-align:center;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                                            >
                                              <span
                                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                                >Abandoned Carts</span
                                              >
                                            </div>
                                          </button>
                                        </li>
                                        <li
                                          class="Polaris-Tabs__TabContainer"
                                          role="presentation"
                                        >
                                          <button
                                            class="Polaris-Tabs__Tab"
                                            :class="{
                                              'Polaris-Tabs__Tab--active':
                                                currentFilterType ===
                                                'recovered'
                                            }"
                                            role="tab"
                                            type="button"
                                            @click="changeFilter('recovered')"
                                          >
                                            <div
                                              class="Polaris-InlineStack"
                                              style="--pc-inline-stack-align:center;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                                            >
                                              <span
                                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                                >Recovered</span
                                              >
                                            </div>
                                          </button>
                                        </li>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="checkouts.docs && checkouts.docs.length > 0"
                      class="Polaris-IndexTable"
                    >
                      <div class="Polaris-IndexTable__IndexTableWrapper">
                        <table class="Polaris-DataTable__Table">
                          <thead>
                            <tr class="hidden md:table-row">
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              >
                                Customer
                              </th>
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              >
                                Date
                              </th>
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              >
                                Recovery Status
                              </th>
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              >
                                Message Status
                              </th>
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              >
                                Checkout id
                              </th>
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              >
                                Total & last order date
                              </th>
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              >
                                Tags
                              </th>
                              <th
                                data-polaris-header-cell="true"
                                class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                scope="col"
                              ></th>
                            </tr>
                          </thead>
                          <tbody>
                            <CartListItem
                              v-for="checkout in checkouts.docs"
                              :key="checkout.id"
                              :checkout="checkout"
                              @refreshCurrentPage="refreshCurrentPage"
                              @openCustomerInfo="openCustomerInfo"
                            />
                          </tbody>
                        </table>

                        <Pagination :page="checkouts" @pageChanged="loadPage" />
                      </div>
                    </div>
                    <div
                      class="align-middle inline-block min-w-full overflow-hidden text-center py-16"
                      v-if="
                        !isLoading &&
                          checkouts.docs &&
                          checkouts.docs.length === 0
                      "
                    >
                      You don't have any {{ currentFilterType }} carts right
                      now. We will be listing them here as soon a cart is
                      {{ currentFilterType }}.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CustomerInfoModal
              v-if="showCustomerInfoModal"
              :phoneNumber="currentCustomerPhoneNumber"
              @close="closeCustomerInfo"
            />
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

import Page from "./Page";

import CartListItem from "./CartListItem";
import Pagination from "./Pagination";
// import ManualMessageAlert from "./ManualMessageAlert";
import CustomerInfoModal from "./CustomerInfoModal.vue";

export default {
  name: "AbadonedCartList",
  data() {
    return {
      pageTitle: "Abandoned carts",
      isLoading: false,
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false,
      currentFilterType: "abandoned"
    };
  },
  components: {
    Page,
    CartListItem,
    Pagination,
    Spinner,
    // ManualMessageAlert,
    CustomerInfoModal
  },
  computed: {
    checkouts() {
      return this.$store.getters.getCheckouts;
    },
    config() {
      return this.$store.getters.getConfig;
    }
  },
  created() {
    this.loadPage(1);
    this.$store.dispatch("getTemplates");
    this.$store.dispatch("getConfig");
  },
  mounted() {
    // eslint-disable-next-line
    // googleTranslateElementInit();
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      await this.$store.dispatch("getAbadonedCarts", {
        page,
        filter: this.currentFilterType
      });
      this.isLoading = false;
    },
    refreshCurrentPage() {
      const page = this.checkouts.page;
      this.loadPage(page);
    },
    openTemplates() {
      this.$router.push({ name: "Templates" });
    },
    openCustomerInfo(phoneNumber) {
      this.currentCustomerPhoneNumber = phoneNumber;
      this.showCustomerInfoModal = true;
    },
    closeCustomerInfo() {
      this.showCustomerInfoModal = false;
    },
    changeFilter(type) {
      this.currentFilterType = type;
      this.page = 1;
      this.loadPage(this.page);
    }
  }
};
</script>

<style lang="scss" scoped>
.Polaris-Button.active {
  background: var(--p-color-bg-hover);
  outline: var(--p-border-width-1);
}
</style>
